import { List } from 'immutable';

import type { RecordOfObjectsState } from '../../objects/types';
import type { RecordOfMatchesState } from '../types';

import type { SupportedLang } from 'app/lang';

import { updateStakesNames } from '../../stakes';
import { updateField } from '../../utils';
import { createImmutableObjects } from './immutable-structures';

// ---

function updateStakeAndBetsNames(
  lang: SupportedLang,
  matchesState: RecordOfMatchesState['byId'],
  objectsState: RecordOfObjectsState,
  matchIdsOfChangedObjects: Set<number> | List<number>,
) {
  matchIdsOfChangedObjects.forEach((matchId) => {
    const prevMatchValue = matchesState.get(matchId);

    if (!prevMatchValue) {
      return;
    }

    const immutableObjects = createImmutableObjects(
      prevMatchValue.objects,
      objectsState.get('byId'),
    );

    const value = updateStakesNames(
      lang,
      immutableObjects,
      prevMatchValue.stakes,
      prevMatchValue.bets,
    );

    matchesState = updateField(matchesState, matchId, 'stakes', value.stakes);
    matchesState = updateField(matchesState, matchId, 'bets', value.bets);
  });

  return matchesState;
}

export default updateStakeAndBetsNames;
